import React, { useEffect, useState } from 'react';
import { FaTimes, FaTrash } from 'react-icons/fa';
import { imagenesCursos } from "../../utils/diccionarioImagenes";

import './CartSidebar.css';

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost/backend_onelearning/api";

export default function CartSidebar({ isOpen, onClose, user }) {
    const [items, setItems] = useState([]);
    const [subtotal, setSubtotal] = useState(0);

    // 1. CARGAR CARRITO AL ABRIR
    useEffect(() => {
        if (isOpen && user) {
            fetchCart();
        }
    }, [isOpen, user]);

    // 2. OBTENER ITEMS DE BD
    const fetchCart = async () => {
        try {
            const res = await fetch(`${API_BASE}/cart/get.php?user_id=${user.id}`, { credentials: 'include' });
            const data = await res.json();
            if (data.status === 'success') {
                setItems(data.items);
                setSubtotal(parseFloat(data.total));
            }
        } catch (error) { console.error("Error cargando carrito", error); }
    };

    // 3. ELIMINAR ITEM
    const removeItem = async (itemId) => {
        try {
            await fetch(`${API_BASE}/cart/remove.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ item_id: itemId }),
                credentials: 'include'
            });
            fetchCart();
        } catch (error) { console.error(error); }
    };

    // NAVEGAR A MI CARRITO
    const handleVerCarrito = () => {
        onClose(); // Cierra el sidebar
        window.location.href = '/mi-carrito'; // Redirige a la página completa
    };

    // 4. INICIAR PAGO RÁPIDO (COMBO SIN CUPÓN)
    const startNiubizPayment = async () => {
        if (items.length === 0) return;
        if (!user || !user.id) {
            alert("Error: No se detecta el usuario logueado. Por favor recarga la página.");
            return;
        }

        console.log("Iniciando sesión de pago rápida...");

        try {
            const res = await fetch(`${API_BASE}/payment/start_niubiz.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ coupon_code: null }), // Desde el sidebar no enviamos cupón
                credentials: 'include' 
            });

            const data = await res.json();

            if (data.status !== 'success') {
                alert("Error Backend: " + data.message);
                return;
            }

            if (window.VisanetCheckout) {
                const nombreCliente = user.first_name || 'Cliente';
                const apellidoCliente = user.last_name || 'Generico';
                let dniCliente = '00000000'; 

                const dniIngresado = prompt("Para generar el código de PagoEfectivo/Yape, por favor ingresa tu DNI:");

                if (dniIngresado && dniIngresado.length >= 8) {
                    dniCliente = dniIngresado;
                } else {
                    alert("Es necesario el DNI para pagos con efectivo. Se usará un genérico para pruebas.");
                }

                window.VisanetCheckout.configure({
                    sessiontoken: data.sessionKey,
                    channel: 'web',
                    merchantid: data.merchantId,
                    purchasenumber: data.purchaseNumber,
                    amount: Number(data.amount),
                    expirationminutes: '20',
                    timeouturl: 'about:blank',
                    merchantlogo: 'https://cdn-icons-png.flaticon.com/512/2111/2111615.png',
                    formbuttoncolor: '#117475',
                    showamount: 'true',
                    firstName: nombreCliente,
                    lastName: apellidoCliente,
                    email: user.email || 'correo@prueba.com',
                    documentType: '1',
                    documentId: dniCliente,
                    phoneNumber: '999888777',
                    recurrence: 'false',
                    action: `${API_BASE}/payment/process_niubiz.php?purchaseNumber=${data.purchaseNumber}`,
                    complete: function (params) {
                        console.log("Formulario completado...");
                    }
                });

                window.VisanetCheckout.open();
            } else {
                alert("El script de Niubiz no cargó. Revisa index.html");
            }
        } catch (error) {
            console.error(error);
            alert("Error de conexión");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="cart-overlay" onClick={onClose}>
            <div className="cart-sidebar" onClick={(e) => e.stopPropagation()}>

                <div className="sidebar-header">
                    <h3>Carrito de Compras</h3>
                    <button className="btn-close-sidebar" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="sidebar-items-container">
                    {items.length === 0 ? (
                        <div className="empty-cart-msg">
                            <p>Tu carrito está vacío.</p>
                        </div>
                    ) : (
                        items.map(item => {
                            const cursoImagen = imagenesCursos[item.course_id]?.desktop || "https://via.placeholder.com/80";

                            return (
                                <div key={item.item_id} className={`sidebar-item ${item.is_locked ? 'locked' : ''}`}>
                                    <div className="sidebar-item-top">
                                        <img src={cursoImagen} alt={item.title} className="sidebar-img" />
                                        
                                        <div className="sidebar-info-block">
                                            <h4 className="sidebar-titulo">{item.title}</h4>
                                            
                                            <div className="sidebar-actions-row">
                                                <button className="sidebar-btn-trash" onClick={() => removeItem(item.item_id)}>
                                                    <FaTrash />
                                                </button>
                                                <span className="sidebar-precio">S/{item.price}</span>
                                            </div>
                                            {item.is_locked && <span className="lock-reason">⛔ {item.lock_reason}</span>}
                                        </div>
                                    </div>
                                    
                                    {!item.is_locked && (
                                        <div className="sidebar-item-bottom">
                                            <p className="sidebar-disclaimer">
                                                * Los cupones de descuento solo se pueden agregar en Carrito
                                            </p>
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>

                {items.length > 0 && (
                    <div className="sidebar-footer">
                        <div className="sidebar-subtotal-row">
                            <div className="sidebar-subtotal-text">
                                <span className="subtotal-label">Subtotal del Pedido</span>
                                <span className="subtotal-tax">* Impuestos incluidos</span>
                            </div>
                            <span className="subtotal-amount">S/{subtotal.toFixed(2)}</span>
                        </div>

                        <div className="sidebar-buttons-row">
                            <button className="btn-sidebar-secondary" onClick={handleVerCarrito}>
                                Ver Carrito
                            </button>
                            <button className="btn-sidebar-primary" onClick={startNiubizPayment}>
                                Comprar
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}